import { PUBLIC_STORAGE_URL } from '@/constants/global'

export const SYMPTOM_OPTIONS = [
  {
    key: 'dor_coluna_cervical',
    name: 'Dor na coluna cervical',
    type: 'AXIAL',
  },
  {
    key: 'dor_toracica',
    name: 'Dor na coluna torácica',
    type: 'AXIAL',
  },
  {
    key: 'dor_lombar',
    name: 'Dor na coluna lombar',
    type: 'AXIAL',
  },
  {
    key: 'dor_nadega',
    name: 'Dor na nádega',
    type: 'AXIAL',
    options: [
      { key: 'varia_lado', name: 'Ela varia de lado' },
      { key: 'irradia_membros_inferiores', name: 'Irradia para membros inferiores' },
      { key: 'parestesias_membros_inferiores', name: 'Tem parestesias nos membros inferiores' },
      { key: 'piora_repouso', name: 'Dor piora em repouso' },
    ],
  },
  {
    key: 'psoriase',
    name: 'Psoríase',
    type: 'PERIFERICO',
    options: [
      {
        key: 'couro_cabeludo',
        name: 'Couro cabeludo',
        imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/couro-cabeludo.jpg',
      },
      { key: 'ungueal', name: 'Ungueal', imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/ungueal.png' },
      {
        key: 'invertida',
        name: 'Invertida',
        imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/psoriase-invertida.jpg',
      },
      {
        key: 'placas',
        name: 'Em placas',
        imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/em-placas.jpg',
      },
      {
        key: 'palmo_plantar',
        name: 'Palmo plantar',
        imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/palmo-plantar.jpg',
      },
      {
        key: 'eritrodermica',
        name: 'Eritrodérmica',
        imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/eritrodermica.jpg',
      },
      {
        key: 'pustulosa_generalizada',
        name: 'Pustulosa generalizada',
        imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/pustulosa-generalisada.jpg',
      },
      { key: 'gutata', name: 'Gutata', imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/gugata.jpg' },
      { key: 'genitais', name: 'Genitais' },
      { key: 'outros', name: 'Outros' },
    ],
  },
  {
    key: 'uveite',
    name: 'Uveíte',
    type: 'PERIFERICO',
    subtitle: 'Olhos vermelhos, irritados, lacrimejando',
  },
  {
    key: 'dactilite',
    name: 'Dactilite',
    type: 'PERIFERICO',
    subtitle: 'Dedos de salsicha',
    imageUrl: PUBLIC_STORAGE_URL + '/disease-examples/dactilite.jpeg',
  },
  {
    key: 'entesite',
    name: 'Entesite',
    type: 'PERIFERICO',
    subtitle: 'Exemplo: dor no local de inserção dos tendões',
  },
  {
    key: 'alteracao_habito_intestinal',
    name: 'Alteração de hábito instestinal',
    type: 'PERIFERICO',
    subtitle: 'Diarreia, sangue nas feses, fissura anal',
  },
  {
    key: 'ulceras_orais_repeticao',
    name: 'Úlceras orais de repetição',
    type: 'PERIFERICO',
  },
  {
    key: 'ulceras_genitais',
    name: 'Úlceras genitais',
    type: 'PERIFERICO',
  },
  {
    key: 'artrite_artralgia',
    name: 'Artrite/artralgia',
    type: 'PERIFERICO',
  },
]
